/**
 * Utilitaires pour la gestion des URLs WebSocket
 */

const BASE_URL = import.meta.env.VITE_API_URL || window.location.origin;
const WS_URL = import.meta.env.VITE_WS_URL; // Optionnel : URL WebSocket dédiée

/**
 * Convertit une URL HTTP/HTTPS en URL WebSocket (ws/wss)
 * @param url URL HTTP/HTTPS
 * @returns URL WebSocket (ws/wss)
 */
function convertToWebSocketUrl(url: string): string {
  if (url.startsWith("https://")) {
    return url.replace("https://", "wss://");
  }
  if (url.startsWith("http://")) {
    return url.replace("http://", "ws://");
  }
  // Si déjà en ws/wss, retourner tel quel
  if (url.startsWith("ws://") || url.startsWith("wss://")) {
    return url;
  }
  // Par défaut, utiliser wss pour les URLs sans schéma
  return `wss://${url}`;
}

/**
 * Obtient l'URL de base pour les connexions WebSocket
 * Utilise VITE_WS_URL si défini, sinon dérive de VITE_API_URL
 * @returns URL de base WebSocket (sans path ni query)
 */
function getWebSocketBaseUrl(): string {
  if (WS_URL) {
    return convertToWebSocketUrl(WS_URL);
  }
  return convertToWebSocketUrl(BASE_URL);
}

/**
 * Construit l'URL complète pour une connexion WebSocket avec authentification
 * Format: ${wsBase}/ws?token=${token}
 * @param token Token JWT pour l'authentification
 * @returns URL WebSocket complète avec token en query
 */
export function getWebSocketUrl(token: string): string {
  const baseUrl = getWebSocketBaseUrl();
  // Supprimer le trailing slash si présent
  const cleanBase = baseUrl.replace(/\/$/, "");
  const encodedToken = encodeURIComponent(token);
  return `${cleanBase}/ws?token=${encodedToken}`;
}
